import { useState } from "react";

const ContactForm = () => {
  const [status, setStatus] = useState("Mesaj Gönder");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [query, setQuery] = useState("");
  const [isChecked, setIsChecked] = useState(false); // Checkbox durumu

  const sendFormData = async () => {
    const formData = {
      name,
      email,
      phone,
      message: query,
    };

    try {
      const response = await fetch("/api/form-gonder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setStatus("Mesaj Gönder");
        alert(data.message);
        // Input alanlarını temizle
        setName("");
        setEmail("");
        setPhone("");
        setQuery("");
        setIsChecked(false);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log("Hata:", error);
      setStatus("Mesaj Gönder");
      alert("Bir şeyler ters gitti. Daha sonra tekrar deneyin.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Telefon numarasının 11 haneli olup olmadığını kontrol et
    const phonePattern = /^0\d{10}$/; // 11 haneli, 0 ile başlayan rakamlar
    if (!phonePattern.test(phone.replace(/\s/g, ''))) {
      alert("Lütfen geçerli bir 11 haneli telefon numarası girin. (Örnek: 05XX XXX XX XX)");
      return;
    }

    if (!isChecked) {
      alert("Lütfen şartları kabul edin."); // Checkbox kontrolü
      return;
    }

    setStatus("Gönderiliyor...");
    sendFormData();
  };

  const handlePhoneChange = (e) => {
    const input = e.target.value.replace(/[^0-9]/g, ''); // Sadece rakamları kabul et
    let formattedInput = '';
    if (input.length > 0) formattedInput += '0';
    if (input.length > 1) formattedInput += input.substring(1, Math.min(4, input.length));
    if (input.length > 4) formattedInput += ' ' + input.substring(4, Math.min(7, input.length));
    if (input.length > 7) formattedInput += ' ' + input.substring(7, Math.min(9, input.length));
    if (input.length > 9) formattedInput += ' ' + input.substring(9, 11);

    setPhone(formattedInput);
  };

  return (
    <div className="form-wrap p-5 mb-5">
      <div className="form-overlay"></div>
      <div className="contact-form text-center">
        <p className="lead text-light">Tavsiye İsteyin</p>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit}>
            <label htmlFor="name" className="form-label text-light">Ad ve Soyad :</label>
            <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" required />
            
            <label htmlFor="email" className="form-label text-light pt-2">E-posta Adresi :</label>
            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" required />
            
            <label htmlFor="phone" className="form-label text-light pt-2">Telefon Numarası :</label>
            <input type="tel" id="phone" value={phone} onChange={handlePhoneChange} className="form-control" required />
            
            <label htmlFor="query" className="form-label text-light pt-2">Mesajınız :</label>
            <textarea className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} id="query" required></textarea>
            
            <div className="form-check form-label d-flex align-items-center mt-4">
              <input type="checkbox" id="terms" className="form-check-input me-2" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} required />
              <label htmlFor="terms" className="form-check-label text-light">KVVK Aydınlatma Metni'ni okudum. Onaylıyorum.</label>
            </div>
            
            <div className="my-4 text-center">
              <button type="submit" className="btn btn-outline-dark">{status}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
